import { c as _c } from "react/compiler-runtime";
import { BackgroundTaskState } from "@faro-lotv/service-wires";
import { isTaskInProgress } from "@hooks/upload-tasks/upload-tasks-utils";
import { useAppSelector } from "@store/store-helper";
import { uploadTasksSelector } from "@store/upload-tasks/upload-tasks-selector";

/**
 * Defined as type because currently both are identical
 */

/**
 * Custom hook that takes care of fetching all upload tasks from store
 */
export function useUploadTasks() {
  const $ = _c(2);
  const uploadTasks = useAppSelector(uploadTasksSelector);
  let taskGroup;
  if ($[0] !== uploadTasks) {
    taskGroup = {
      abortedTasks: [],
      failedTasks: [],
      inProgressTasks: [],
      successfulTasks: []
    };
    uploadTasks.forEach(uploadTask => {
      if (isTaskInProgress(uploadTask)) {
        taskGroup.inProgressTasks.push(uploadTask);
      } else {
        if (uploadTask.status === BackgroundTaskState.aborted) {
          taskGroup.abortedTasks.push(uploadTask);
        } else {
          if (uploadTask.status === BackgroundTaskState.failed) {
            taskGroup.failedTasks.push(uploadTask);
          } else {
            if (uploadTask.status === BackgroundTaskState.succeeded) {
              taskGroup.successfulTasks.push(uploadTask);
            }
          }
        }
      }
    });
    $[0] = uploadTasks;
    $[1] = taskGroup;
  } else {
    taskGroup = $[1];
  }
  return taskGroup;
}